import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@ingka/button';
import Tooltip from '@ingka/tooltip';
import { openExport } from '../../../store/actions/modal/openExport';
import ArrowDownToBase from '@ingka/ssr-icon/paths/arrow-down-to-base';

import { selectHasOngoingExports } from '../../../store/slices/ongoingrequests';
import type { AppThunkDispatch } from '../../../store';

const ExportButton = function ExportButton() {
  const dispatch = useDispatch<AppThunkDispatch>();
  const isExporting = useSelector(selectHasOngoingExports);
  const openExportDialog = useCallback(() => dispatch(openExport()), [dispatch]);

  return (
    <Tooltip
      describedById="export-button-tooltip"
      interactiveCustomTrigger
      tooltipText="Export"
      position="bottom"
    >
      <Button
        disabled={isExporting}
        iconOnly
        size="small"
        aria-label="Open export dialog"
        onClick={openExportDialog}
        ssrIcon={ArrowDownToBase}
        type="tertiary"
      />
    </Tooltip>
  );
};

export default ExportButton;
